import {useMutation} from "@tanstack/react-query";
import {AxiosResponse} from "axios";
import {IGenericAuthResponse} from "../../user/user";
import {queryClient} from "../../../App";
import {startAddNotification} from "../../core/core";
import {INotificationType} from "../../../components/ui/notifications/item/NotificationItem";
import {useAppDispatch} from "../../hooks";
import {IUseGetDevices} from "../useQueryGetDevices";
import {IGetDevices} from "../../types";
import {STATIC_STRINGS} from "../../static/staticTexts";
import {deleteDeviceService} from "../../user/saga/auth/delete-device";

export const IUseMutationDeleteDevice = 'IUseMutationDeleteDevice';

export function useMutationDeleteDevice() {
  const dispatchStore = useAppDispatch();

  return useMutation({
    mutationKey: [IUseMutationDeleteDevice],
    mutationFn: (id: string) => deleteDeviceService(id),
    onMutate: async (id) => {
      await queryClient.cancelQueries({ queryKey: [IUseGetDevices] });

      await queryClient.invalidateQueries({
        queryKey: [IUseGetDevices]
      });

      const previousDevices = queryClient.getQueryData<AxiosResponse<IGenericAuthResponse<IGetDevices[]>>>([IUseGetDevices]);

      queryClient.setQueryData<AxiosResponse<IGenericAuthResponse<IGetDevices[]>>>([IUseGetDevices], (prevData) => {
        if (!prevData) {
          return
        }

        const items = prevData.data.data.filter(dataItem => dataItem.deviceUuid.toLowerCase().trim() !== id)

        return {
          ...prevData,
          data: {
            ...prevData.data,
            data: items
          }
        };
      })

      dispatchStore(startAddNotification({
        title: STATIC_STRINGS.NOTIFICATIONS.DELETE_DEVICE.SUCCESS.TITLE,
        description: STATIC_STRINGS.NOTIFICATIONS.DELETE_DEVICE.SUCCESS.CONTENT,
        type: INotificationType.SUCCESS
      }));

      return { previousDevices };
    },
    onError: (err, newItem, context) => {
      if (!context) {
        return;
      }

      queryClient.setQueryData([IUseGetDevices], context.previousDevices)

      dispatchStore(startAddNotification({
        title: STATIC_STRINGS.NOTIFICATIONS.DELETE_DEVICE.ERROR.TITLE,
        description: STATIC_STRINGS.NOTIFICATIONS.DELETE_DEVICE.ERROR.CONTENT,
        type: INotificationType.ERROR
      }));
    },
    onSettled: () => {
      return queryClient.invalidateQueries({ queryKey: [IUseGetDevices] })
    },
  })
}
